import { LoadingState } from '@lcs/shared/api';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections, OrderingOption } from 'generated/graphql-types';
import {
   createRegisterAdapter,
   RegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { ActiveCallsRegisterOptions } from '../../models/active-calls-register-options';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import * as actions from '../account-call-history/account-call-history.actions';
import { createCallRegisterReducer } from '../register-reducer.factory';
import { SharedCallRegisterState } from '../shared-register-state.model';

export const accountCallHistoryFeatureKey = 'accountCallHistory';

export interface AccountCallHistoryState extends SharedCallRegisterState {}

const adapter: RegisterAdapter<ActiveCallsRegisterListItem, ActiveCallsRegisterOptions, OrderingOption> =
   createRegisterAdapter<ActiveCallsRegisterListItem, ActiveCallsRegisterOptions, OrderingOption>({
      selectId: (item) => item.callDetailId ?? 0,
   });

const entityAdapter: EntityAdapter<ActiveCallsRegisterListItem> = createEntityAdapter<ActiveCallsRegisterListItem>({
   selectId: (item) => item.callDetailId,
   sortComparer: (a, b) => b.callDetailId - a.callDetailId,
});

const today = new Date();
const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(today.getDate() - 30);

const initialActiveCallsQuickFilters: ActiveCallsRegisterOptions = {
   account: undefined,
   serverName: undefined,
   startDate: thirtyDaysAgo,
   endDate: today,
   duration: undefined,
   callDirection: undefined,
   callDisposition: undefined,
   extensionGroupExtensions: undefined,
   searchText: '',
   providerId: undefined,
};
const initialState: AccountCallHistoryState = {
   ...adapter.getInitialState(),
   filters: [],
   isAutoRefresh: false,
   orderingOptions: [{ direction: OrderingDirections.Desc, field: 'startTime' }],
   callState: LoadingState.Init,
   quickFilters: initialActiveCallsQuickFilters,
   endCursor: null,
   hasNextPage: false,
   totalCount: 0,
};

export const accountCallHistoryReducer = createCallRegisterReducer(
   adapter,
   entityAdapter,
   actions.accountCallHistoryRegisterAdapterActions,
   initialState,
   on(actions.callHistoryRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(actions.setOrderingOptionsFromSessionStorage, (state, action) => ({
      ...state,
      orderingOptions: action.orderingOptions,
   }))
);

export const accountCallHistoryRegisterSelector =
   createFeatureSelector<AccountCallHistoryState>(accountCallHistoryFeatureKey);
export const selectors = adapter.getSelectors(accountCallHistoryRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectEndCursor,
   selectQuickFilters,
   selectOrderingOptions,
} = adapter.getSelectors(accountCallHistoryRegisterSelector);
